import React from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { generateRecurringDates } from "./WizardConstants";

export function WizardStepDeliverables({ form, updateDeliverable, addDeliverable, removeDeliverable }) {
  return (
    <div className="space-y-4" data-testid="wizard-step-deliverables-content">
      <div>
        <h2 className="text-lg font-medium">Deliverables</h2>
        <p className="text-sm text-slate-500 mt-1">What does the supplier need to deliver? Mark recurring items for automatic date generation.</p>
      </div>
      <div className="space-y-3">
        {form.deliverables.map((d, i) => (
          <div key={`del-${i}`} className="border rounded-sm p-3 space-y-2" data-testid={`wizard-deliverable-${i}`}>
            <div className="flex gap-2 items-start">
              <span className="w-6 h-8 flex items-center justify-center text-xs text-slate-400 shrink-0 font-medium">{i + 1}.</span>
              <Input value={d.description} onChange={e => updateDeliverable(i, "description", e.target.value)} placeholder="e.g., Monthly performance report" className="rounded-sm flex-1" />
              {form.deliverables.length > 1 && (
                <Button variant="ghost" size="icon" className="h-9 w-9 text-red-400 shrink-0" onClick={() => removeDeliverable(i)}>x</Button>
              )}
            </div>
            <div className="flex gap-2 items-end ml-8">
              <div className="space-y-1 flex-1">
                <Label className="text-[10px] text-slate-400">{d.recurrence === "once" ? "Delivery Date" : "First Delivery Date"}</Label>
                <Input type="date" value={d.delivery_date} onChange={e => updateDeliverable(i, "delivery_date", e.target.value)} className="rounded-sm h-8 text-sm" />
              </div>
              <div className="space-y-1 flex-1">
                <Label className="text-[10px] text-slate-400">Frequency</Label>
                <Select value={d.recurrence || "once"} onValueChange={v => updateDeliverable(i, "recurrence", v)}>
                  <SelectTrigger className="rounded-sm h-8 text-sm" data-testid={`deliverable-recurrence-${i}`}><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="once">One-off</SelectItem>
                    <SelectItem value="weekly">Weekly</SelectItem>
                    <SelectItem value="fortnightly">Fortnightly</SelectItem>
                    <SelectItem value="monthly">Monthly</SelectItem>
                    <SelectItem value="quarterly">Quarterly</SelectItem>
                    <SelectItem value="biannually">Bi-annually</SelectItem>
                    <SelectItem value="annually">Annually</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              {d.recurrence && d.recurrence !== "once" && (
                <div className="space-y-1 flex-1">
                  <Label className="text-[10px] text-slate-400">Until (End Date)</Label>
                  <Input type="date" value={d.recurrence_end || form.expiration_date || ""} onChange={e => updateDeliverable(i, "recurrence_end", e.target.value)} className="rounded-sm h-8 text-sm" />
                </div>
              )}
            </div>
            {d.recurrence && d.recurrence !== "once" && d.delivery_date && (
              <div className="ml-8 mt-1">
                <p className="text-[10px] text-violet-600 font-medium">
                  Generates {generateRecurringDates(d.delivery_date, d.recurrence, d.recurrence_end || form.expiration_date).length} occurrence(s) — {d.recurrence} from {d.delivery_date}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
      <Button variant="outline" size="sm" onClick={addDeliverable} className="rounded-sm gap-1.5" data-testid="wizard-add-deliverable">+ Add Deliverable</Button>
      <p className="text-xs text-slate-400">Tip: Recurring deliverables will generate individual tracked items for each occurrence date.</p>
    </div>
  );
}
